import React from "react";
import UnclaimButton from "@components/FlowActionButtons/UnclaimButton";
import type { Task } from "@services/vesselCall/types";
import { useUnclaimVesselCall } from "./hooks";
import { canUserUnclaim, VESSEL_CALL_STATUSES } from "./utils";

interface UnclaimVesselCallProps {
  refetchVesselCall: () => void;
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const UnclaimVesselCall: React.FC<UnclaimVesselCallProps> = ({
  vesselCallFlowData,
  refetchVesselCall,
}) => {
  const { onUnclaimVesselCall } = useUnclaimVesselCall(
    vesselCallFlowData?.vesselCallId,
    refetchVesselCall,
  );

  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable =
    vesselCallFlowData.status !== VESSEL_CALL_STATUSES.DEPARTED &&
    canUserUnclaim(vesselCallFlowData.task?.status, vesselCallFlowData.task?.claimOwnerName);
  return (
    <UnclaimButton
      langBase={LANG_BASE}
      permission="canUnclaimVesselCall"
      isActionAvailable={isActionAvailable}
      onUnclaim={onUnclaimVesselCall}
    />
  );
};
export default UnclaimVesselCall;
